import { render, staticRenderFns } from "./StackEditor.vue?vue&type=template&id=47660e4b&"
import script from "./StackEditor.vue?vue&type=script&lang=js&"
export * from "./StackEditor.vue?vue&type=script&lang=js&"
import style0 from "./StackEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports